<template src='./TarjetaMiniatura.html'>
    
</template>
<script>
import { serverBus } from '../../main'
export default {
    data() {
        return { 
        }
    },
    props: {
        formulariosLlenosTipoMomento:{
            type: Array,
            required: true
        }
    },
    methods: {
        abrirTarjetaFormularioMomento(formulario_id, nombreCategoria,valor, coleccion) {
            this.$store.dispatch("setIdFormulario", null);
            serverBus.$emit("abrirTarjetaFormulario", formulario_id, nombreCategoria,valor, coleccion); 
        } 
    },
}
</script>
<style lang="scss" src='./TarjetaMiniatura.scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/TarjetaMiniatura/TarjetaMiniatura.vue